import React, {Component} from 'react';
import moment from 'moment';

// Components
import TopImagesCarousel from './top_images_carousel';

const calendarImg = require('images/admin/campaign_wrap_up/icons/icon-calendar.png');

class CampaignWrapUpHeader extends Component {
    displayHeaderSubtitle = () => {
        const {renderForPdf, campaignName} = this.props;

        if (renderForPdf) {
            return null;
        }

        return (
            <div className="header-body-subtitle">
                Congrats! Your <b>{campaignName}</b> Campaign has completed. Check out this
                comprehensive report for insights into your campaign analytics, highest performing
                content, consumer sentiment, creator participation analysis, audience analytics, and
                more!
            </div>
        );
    };

    render() {
        const {
            renderForPdf,
            bgColor,
            getAssetPath,
            brandLogoUrl,
            brandName,
            campaignName,
            startDate,
            endDate
        } = this.props;
        const formattedStartDate = moment(new Date(startDate)).format('M-D-YY');
        const formattedEndDate = moment(new Date(endDate)).format('M-D-YY');
        const calendarImgPath = getAssetPath(calendarImg);
        const headerSubtitle = this.displayHeaderSubtitle();

        return (
            <div className="campaign-wrap-up-header">
                <div className="header-body">
                    <div className="header-body-info">
                        <div className="header-body-title">
                            <h2>{brandName}</h2>
                            <h1>{campaignName} Campaign Recap Report</h1>
                        </div>
                        {headerSubtitle}
                        <div className="header-dates-logo">
                            <div className="header-dates">
                                <div className="calendar-img" />
                                <div className="dates-text">
                                    <div>
                                        <span className="dates-text-title">Campaign Dates</span>
                                    </div>
                                    <div>
                                        <span className="dates-mdy">{formattedStartDate}</span>
                                        <span className="dates-text-title"> to </span>
                                        <span className="dates-mdy">{formattedEndDate}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="header-logo" />
                        </div>
                    </div>
                    <TopImagesCarousel
                        topImages={this.props.topImages}
                        renderForPdf={this.props.renderForPdf}
                    />
                </div>

                {/*STYLES*/}

                <style>{`
                    .campaign-wrap-up-header {
                        background-color: ${bgColor};
                    }

                    .calendar-img {
                        background-image: url(${calendarImgPath});
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: contain;
                        width: 25px;
                        height: 25px;
                    }

                    .dates-text {
                        color: #00A1E1;
                        padding-left: 16px;
                    }

                    .dates-text-title {
                        font-size: 18px;
                    }

                    .dates-italic {
                        font-style: italic;
                    }

                    .dates-mdy {
                        font-size: 18px;
                    }

                    .header-logo {
                        background-image: url(${brandLogoUrl});
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: contain;
                        width: 100px;
                        height: 100px;
                    }

                    .header-body {
                        padding: 40px 5% 120px;
                    }

                    .header-body-title {
                        padding: 10px 0px;
                    }

                    .header-body-title h1 {
                        font-size: 40px;
                        font-weight: 300;
                        color: #575757;
                        margin: 0;
                        padding: 5px 0px;
                    }

                    .header-body-title h2 {
                        font-size: 20px;
                        font-weight: 600;
                        color: #575757;
                        margin: 0;
                        padding: 5px 0px;
                    }

                    .header-body-subtitle {
                        width: 90%;
                        font-size: 20px;
                        font-weight: 300;
                        padding: 10px 0px;
                    }
                `}</style>

                {/*STYLE FOR WEB*/}
                {!renderForPdf ? (
                    <style>{`
                        .header-dates-logo {
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-start;
                        }

                        .header-dates {
                            display: flex;
                            align-items: center;
                        }

                        .dates-text {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                        }

                        .header-body {
                            display: flex;
                            align-items: center;
                        }

                        .header-body-info {
                            display: flex;
                            flex-direction: column;
                            width: 40%;
                        }

                        .header-logo {
                            display: none;
                        }
                    `}</style>
                ) : null}

                {/*STYLE FOR PDF*/}
                {renderForPdf ? (
                    <style>{`
                        .campaign-wrap-up-header {
                            padding-top: 40px;
                        }

                        .calendar-img {
                            display: inline-block;
                            vertical-align: middle;
                        }

                        .header-body {
                            width: 90%;
                            padding: 0;
                            margin: auto;
                        }

                        .header-logo {
                            position: absolute;
                            top: 40px;
                            right: 5%;
                            width: 200px;
                            height: 200px;
                        }

                        .dates-text {
                            display: inline-block;
                            vertical-align: middle;
                        }

                        .header-body-info {
                            padding-bottom: 40px;
                        }
                    `}</style>
                ) : null}
            </div>
        );
    }
}

CampaignWrapUpHeader.propTypes = {};

export default CampaignWrapUpHeader;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/campaign_wrap_up_header/index.js